module.exports = __webpack_public_path__ + "public/Icons/12Manageservicefee.svg?b4f5ba55";